import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25da8c06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "选择能发起该审批的组织/部门/岗位/人员，不选则默认开放给所有人", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择组织")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("选择部门")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择岗位")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("选择人员")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_picker_items = _resolveComponent("picker-items")!
  const _component_org_picker = _resolveComponent("org-picker")!
  const _component_dept_picker = _resolveComponent("dept-picker")!
  const _component_post_picker = _resolveComponent("post-picker")!
  const _component_user_picker = _resolveComponent("user-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_el_button, {
      class: "mt-10px",
      size: "default",
      icon: _ctx.orgIcon,
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.orgPickerOpen(true))),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(_component_picker_items, {
      modelValue: _ctx.assignedOrg,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.assignedOrg) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      class: "mt-10px",
      size: "default",
      icon: _ctx.deptIcon,
      type: "primary",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deptPickerOpen(true))),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(_component_picker_items, {
      modelValue: _ctx.assignedDept,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.assignedDept) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      class: "mt-10px",
      size: "default",
      icon: _ctx.postIcon,
      type: "primary",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.postPickerOpen(true))),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(_component_picker_items, {
      modelValue: _ctx.assignedPost,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.assignedPost) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      class: "mt-10px",
      size: "default",
      icon: _ctx.userIcon,
      type: "primary",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.userPickerOpen(true))),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(_component_picker_items, {
      modelValue: _ctx.assignedUser,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.assignedUser) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_org_picker, {
      ref: "orgPicker",
      multiple: _ctx.orgMultiple,
      selected: _ctx.assignedOrg,
      onOk: _ctx.orgSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_dept_picker, {
      ref: "deptPicker",
      multiple: _ctx.deptMultiple,
      selected: _ctx.assignedDept,
      onOk: _ctx.deptSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_post_picker, {
      ref: "postPicker",
      multiple: _ctx.postMultiple,
      selected: _ctx.assignedPost,
      onOk: _ctx.postSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_user_picker, {
      ref: "userPicker",
      multiple: _ctx.userMultiple,
      selected: _ctx.assignedUser,
      onOk: _ctx.userSelected
    }, null, 8, ["multiple", "selected", "onOk"])
  ]))
}